import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import LoadingButton from '@/components/Buttons/LoadingButton';

interface Props {
    userName?: string;
    onClose: () => void;
    onConfirm: () => void;
}

export default function ReinitiateIDVConfirmDialog({ userName, onClose, onConfirm }: Props) {
    return (
        <Dialog open onClose={onClose}>
            <DialogTitle>Re-initiate ID Verification?</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ paddingTop: '8px' }}>
                    <Typography variant="body2">
                        <Typography component="span" fontWeight={600}>
                            {userName}
                        </Typography>{' '}
                        has already completed the ID Verification process, and more than 14 days
                        have passed since its completion.
                    </Typography>
                    <Typography variant="body2">
                        Re-initiating the ID Verification will start a new process for the client,
                        and an additional charge will apply.
                    </Typography>
                    <Typography variant="body2">Do you want to continue?</Typography>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined" color="primary">
                    Cancel
                </Button>
                <LoadingButton loading={false} onClick={onConfirm} variant="contained">
                    Confirm
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
